import { Box, Container, Stack, useTheme } from "@mui/material";
import { CartButton } from "./cart-button.js";
import { darken } from "color2k";
import { DesktopStickyHeader } from "./desktop-sticky.js";
import { LocalizationContext } from "../localization/index.js";
import { Logo } from "../logo/index.js";
import { NavItem } from "./desktop-item.js";
import { useContrastColor } from "../utilities/index.js";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import React from "react";
export const DesktopHeader = ({ bgColor = "white", color, items = [], }) => {
    const { mode } = React.useContext(LocalizationContext);
    const theme = useTheme();
    const contrastColor = useContrastColor(bgColor);
    const textColor = color ?? contrastColor;
    const indicatorColor = darken(bgColor, 1.5);
    const { t } = useTranslation("c-common");
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { component: "header", sx: {
                backgroundColor: "transparent",
                color: textColor,
                height: "100px",
                left: 0,
                pb: 0,
                position: "absolute",
                pt: 0,
                right: 0,
                top: 0,
                width: "100%",
                zIndex: 30,
            } },
            React.createElement(Container, { maxWidth: false, sx: { maxWidth: theme.breakpoints.values.xl } },
                React.createElement(Stack, { alignItems: "center", direction: "row", justifyContent: "space-between", sx: { px: 0, py: 2 } },
                    React.createElement(Box, { sx: { height: "auto", pt: { md: 0.75, xl: 0.55 }, width: { md: "282px", xl: "340px" } } },
                        React.createElement(Link, { "aria-label": "Startseite", href: "/", title: t("seo-site-title") },
                            React.createElement(Logo, { fill: textColor, variant: "horizontal", title: t("seo-site-title") }))),
                    React.createElement(Box, null,
                        React.createElement(Stack, { spacing: { xs: 3, lg: 5 }, direction: "row" },
                            items.map((item) => (React.createElement(NavItem, { key: item.label, indicatorColor: indicatorColor, item: item }))),
                            mode === "store" && React.createElement(CartButton, { color: textColor })))))),
        React.createElement(DesktopStickyHeader, { items: items })));
};
//# sourceMappingURL=desktop-header.js.map